import useToken from '../../../hooks/useToken';
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Button, Card, Col, Form, Row, Spinner } from 'react-bootstrap';
import { FiUser, FiMail, FiCalendar, FiCamera, FiLoader, FiMessageSquare, FiSave, FiInfo,  FiUsers, FiTag,FiCheckCircle, FiCreditCard,FiLock,FiMapPin,FiRefreshCw,FiX, FiPhone } from 'react-icons/fi';
import IconButton from 'components/common/IconButton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import { useToast } from 'context/providers/ToastProvider';
import SeccionArchivosEmpleados from './SeccionArchivosEmpleados';

const RegistroEmpleado = (
    empleado
) => {
  
    const { token, setToken } = useToken();
    const navigate = useNavigate();
    const { showErrorToast, showSuccessToast } = useToast();
    const [tipoUsuario, setTipoUsuario] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [guardando, setGuardando] = useState(false);

    const [activo, setActivo] = useState('');
    const [arrastrarImagen, setArrastrarImagen] = useState(false);
    const [imagen, setImagen] = useState({
        file: null,
        fileName: ''
    });
    const [usuario, setUsuario] = useState({
        idUsuario: 0,
        vUsuario : '',
        vContrasena: '',
        idCatTipoUsuario: '',
        vNombre: '',
        vApellidos: '',
        vCURP: '',
        vFoto: '',
        vImageName: '',
        dFechaNacimiento: '',
        vDomicilioPersonal: '',
        vDatosContactoPersonal: '',
        vTelefonoTrabajo: '',
        vEmailTrabajo: '',
        dFechaIngreso: '',

        iCategoria: '',
        bIsActive: '',
    });

    //Se carga la primera vez
    useEffect(() => {
        validarEmpleado();
        obtenerTipoUsuario();

    
    }, []);

    //Funcion para validar entre si es un usuario nuevo o un usuario a editar
    const validarEmpleado = async () => {
        //setCargando(true)
        if (empleado?.empleado) {

            setUsuario(empleado.empleado);
            setActivo(empleado.empleado.bIsActive ? "1" : "0");
            // Actualizar el estado de la imagen con los datos del empleado
            setImagen({
                file: empleado.empleado.vFoto,       // Base64 de la imagen
                fileName: empleado.empleado.vImageName // Nombre del archivo
            });
        }
    }

    //Funcion para modificar el valor de state usuario mediane values
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUsuario({ ...usuario, [name]: value });
    };

    /**
     * Funcion para obtener LOS TIPOS DE USUARIO
     */
    const obtenerTipoUsuario = async () => {
        const response = await fetch("/api/usuario/ObtenerTipoUsuario",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            console.log("==== OBTENER TIPO USUARIO ====");

            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                console.log("ObjDetalles:", ObjDetalles);

                setTipoUsuario(ObjDetalles.table2);

                console.log("USUARIO:", ObjDetalles.table2);

            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        
    };

    //Funcion para guardar un nuevo usuario
    const guardarUsuario = async (e) => {
        e.preventDefault();
        setGuardando(true)
        const data = {
            //datos a enviar
            idUsuario: usuario.idUsuario || 0,
            vUsuario: usuario.vUsuario,
            vContrasena: usuario.vContrasena,
            idCatTipoUsuario: usuario.idCatTipoUsuario,
            vNombre: usuario.vNombre,
            vApellidos: usuario.vApellidos,
            vCURP: usuario.vCURP,
            dFechaNacimiento: usuario.dFechaNacimiento,
            vFoto: imagen.file,
            vDomicilioPersonal: usuario.vDomicilioPersonal,
            vDatosContactoPersonal: usuario.vDatosContactoPersonal,
            vTelefonoTrabajo: usuario.vTelefonoTrabajo,
            vEmailTrabajo: usuario.vEmailTrabajo,
            vImageName: imagen.fileName,
            dFechaIngreso: usuario.dFechaIngreso,

            iCategoria: usuario.iCategoria,
            bIsActive: activo
        };

        console.log("Enviando datos:", data);

        try {
            const response = await fetch("/api/usuario/GuardarActualizarUsuario", {
                method: "POST",
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {

                const objResponse = await response.json();

                if (objResponse.iResponseType == 1) {
                    setCargando(false);
                    showSuccessToast("Usuario guardado correctamente");
                    navigate("/contabilidad/empleados");

                } else {
                    showErrorToast(objResponse.vMessage);
                }
                setGuardando(false)

            } else {
                showErrorToast(response.status + ' ' + response.statusText);
            }
        } catch (error) {
            console.error("Error de conexión", error);
            showErrorToast("Error de conexión: " + error.message);
            setToken(null);
            setGuardando(false)

        }

        
    };

    //Generar contraseña automatica segura 
    const GenerarContrasena = async (action) => {
        const response = await fetch("/api/usuario/GenerarContrasena", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'text/plain'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.text();
            console.log(data);
            if (action == 'Contrasena') {
                setUsuario((prevUsuario) => ({
                    ...prevUsuario,          // Copia todos los campos existentes
                    vContrasena: data,       // Sobrescribe solo el campo vContrasena
                }));
            } else {
                setUsuario((prevUsuario) => ({
                    ...prevUsuario,          // Copia todos los campos existentes
                    vContrasena: data,       // Sobrescribe solo el campo vContrasena
                }));
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                navigate("");
            }

        }

    };
    // Selecciona el archivo de imagen
    const seleccionarImagen = (e) => {
        
        const file = e.target.files[0];

        if (file) {
            // Validar tipo de archivo
            const allowedTypes = ['image/jpeg', 'image/png'];
            if (!allowedTypes.includes(file.type)) {
                console.error("Formatos permitidos: JPG, PNG");
                showErrorToast("Solo se permiten archivos JPG y PNG.");
                return;
            }
            // Validar tamaño del archivo (2 MB = 2 * 1024 * 1024 bytes)
            const MAX_FILE_SIZE = 2 * 1024 * 1024;
            if (file.size > MAX_FILE_SIZE) {
                console.error("Tamaño excedido");
                showErrorToast("El tamano maximo permitido es 2MB.");
                return;
            }
            // Validar extensión del archivo (case insensitive)
            const validExtensions = ['.jpg', '.jpeg', '.png'];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                console.error("Extensiones permitidas: .jpg, .jpeg, .png");
                showErrorToast("Extensión no válida. Use JPG o PNG.");
                return;
            }
      
            // Si todas las validaciones son correctas, procesar el archivo
            procesarArchivo(file, setImagen);
        }
    };

    // Manejar arrastrar imagenes
    const handleDrag = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragover" || e.type === "dragenter") {
            setArrastrarImagen(true);
        } else if (e.type === "dragleave") {
            setArrastrarImagen(false);
        }
    }, []);

    // Manejar soltar imagenes
    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        setArrastrarImagen(false);

        const files = e.dataTransfer.files;
        if (files && files.length > 0) {
            seleccionarImagen({ target: { files } }); // Reutilizamos la misma función del input
        }
    }, [seleccionarImagen]);

    //Procesa la imagen seleccionada
    const procesarArchivo = (file, setArchivo) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            const base64String = event.target.result.split(",")[1];
            setArchivo({
                fileName: file.name,
                file: base64String
            });
            console.log("ARCHIVO Y NOMBRE", { fileName: file.name, file: base64String }); // Para depuración
        };

        reader.onerror = () => {
            console.error("Error al leer el archivo.");
        };

        reader.readAsDataURL(file);
    };

    //Funcion para borrar imagen
    const borrarImagen = () => {
        // Limpiar estados principales
        setImagen(prev => ({
            ...prev,
            file: '',
            fileName: null
        }));

        // Limpiar estado de previsualización
        setImagen({ file: null });

        // Resetear input de archivo
        const fileInput = document.getElementById('formFoto');
        if (fileInput) fileInput.value = '';
    };

    return (
        <>
            {!cargando ?
                <>
                <Card className="mb-2">
                    <Card.Header className="d-flex align-items-center ">
                        <IconButton
                            onClick={() => navigate('/contabilidad/empleados')}
                            variant="falcon-default"
                            size="sm"
                            icon="arrow-left"
                            className="me-2" 
                        />
                        {/* Contenedor central (ocupa espacio restante) */}
                        <div className="d-flex align-items-center justify-content-center flex-grow-1">
                            <img
                                src="/img/team/nofoto50.png"
                                alt="connectCircle"
                                height={40}
                                className="me-2"
                            />
                            <h3 style={{ lineHeight: '1', marginBottom: -6 }}>
                                {empleado.empleado ? usuario.vNombre + ' ' + usuario.vApellidos : 'Registro de nuevo Empleado'}
                            </h3>
                        </div>
                    </Card.Header>
                </Card>

                <Card>

                        <Card.Body className="p-4">
                           

                            <Row>
                                {/* Información Personal */}
                                <Col lg={6} md={12} className="mb-4">
                                    <div className="personal-info-section">
                                        <h6 className="text-secondary mb-3 d-flex align-items-center">
                                            <div style={{ width: '4px', height: '20px', backgroundColor: '#28a745', marginRight: '8px', borderRadius: '2px' }}></div>
                                            Información Personal
                                        </h6>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiUser className="me-2 text-success" />
                                                <span>Nombre <span style={{ color: '#e74c3c' }}>*</span></span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                autoComplete="off"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                placeholder="Ingresa el nombre del empleado"
                                                name="vNombre"
                                                value={usuario.vNombre ?? ''}
                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    paddingLeft: '12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiUser className="me-2 text-success" />
                                                <span>Apellidos <span style={{ color: '#e74c3c' }}>*</span></span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                autoComplete="off"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                placeholder="Ingresa los apellidos del empleado"
                                                name="vApellidos"
                                                value={usuario.vApellidos ?? ''}
                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    paddingLeft: '12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiCreditCard className="me-2 text-info" />
                                                <span>C.U.R.P</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                autoComplete="off"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                placeholder="Ingresa la CURP"
                                                name="vCURP"
                                                value={usuario.vCURP ?? ''}
                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    paddingLeft: '12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiCalendar className="me-2 text-warning" />
                                                <span>Fecha de Nacimiento <span style={{ color: '#e74c3c' }}>*</span></span>
                                            </Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="dFechaNacimiento"
                                                value={usuario.dFechaNacimiento?.split('T')[0] || ''}

                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    paddingLeft: '12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiMapPin className="me-2 text-danger" />
                                                <span>Domicilio Personal</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                autoComplete="off"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                placeholder="Ingresa el domicilio"
                                                name="vDomicilioPersonal"
                                                value={usuario.vDomicilioPersonal ?? ''}

                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    paddingLeft: '12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                            />
                                        </Form.Group>

                                        {/* Fotografía debajo del domicilio */}
                                        <Col md={6} className="mb-3">
                                            {/* Fotografía debajo del domicilio */}
                                            <Form.Group>
                                                <Form.Label className="d-flex align-items-center mb-3">
                                                    <FiCamera className="me-2 text-primary" />
                                                    <span className="fw-semibold">Fotografía</span>
                                                </Form.Label>
                                                <div className="d-flex justify-content-start">
                                                    <div
                                                        style={{
                                                            width: '120px',
                                                            height: '120px',
                                                            border: arrastrarImagen ? '2px dashed #007bff' : '2px dashed #e0e0e0',
                                                            borderRadius: '8px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            overflow: 'hidden',
                                                            position: 'relative',
                                                            backgroundColor: arrastrarImagen ? '#f8f9ff' : '#fafafa',
                                                            transition: 'all 0.3s ease',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.08)'
                                                        }}
                                                        onDragOver={handleDrag}
                                                        onDragEnter={handleDrag}
                                                        onDragLeave={handleDrag}
                                                        onDrop={handleDrop}
                                                    >
                                                        <Form.Control
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={seleccionarImagen}
                                                            style={{ display: 'none' }}
                                                            id="fileInput"
                                                        />

                                                        <label
                                                            htmlFor="fileInput"
                                                            style={{
                                                                cursor: 'pointer',
                                                                width: '100%',
                                                                height: '100%',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            {imagen?.file ? (
                                                                <img
                                                                    src={`data:image/jpeg;base64,${imagen.file}`}

                                                                    alt={`Previsualización de ${imagen.fileName}`}
                                                                    style={{
                                                                        width: '100%',
                                                                        height: '100%',
                                                                        objectFit: 'cover'
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div style={{ textAlign: 'center', padding: '10px' }}>
                                                                    <FiCamera size={20} style={{ color: '#007bff', marginBottom: '4px' }} />
                                                                    <div>
                                                                        <span style={{ color: '#007bff', fontWeight: '600', display: 'block', fontSize: '10px' }}>
                                                                            Clic o arrastra
                                                                        </span>
                                                                        <small style={{ color: '#666', display: 'block', fontSize: '9px' }}>

                                                                            JPG, PNG
                                                                        </small>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </label>

                                                        {imagen?.file && (
                                                            <button
                                                                type="button"
                                                                onClick={borrarImagen}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '4px',
                                                                    right: '4px',
                                                                    background: '#ff4757',
                                                                    color: 'white',
                                                                    border: 'none',
                                                                    borderRadius: '50%',
                                                                    width: '20px',
                                                                    height: '20px',
                                                                    cursor: 'pointer',
                                                                    zIndex: 2,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    fontSize: '10px',
                                                                    boxShadow: '0 2px 4px rgba(255,71,87,0.3)',
                                                                    transition: 'all 0.2s ease'
                                                                }}
                                                            >
                                                                <FiX />
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                    </div>
                                </Col>

                                {/* Configuración del Sistema */}
                                <Col lg={6} md={12} className="mb-4">
                                    {/* Configuración del Sistema */}
                                    <div className="system-config-section">
                                        <h6 className="text-secondary mb-3 d-flex align-items-center">
                                            <div style={{ width: '4px', height: '20px', backgroundColor: '#007bff', marginRight: '8px', borderRadius: '2px' }}></div>
                                            Configuración del Sistema
                                        </h6>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiUsers className="me-2 text-primary" />
                                                <span>Tipo Usuario <span style={{ color: '#e74c3c' }}>*</span></span>
                                            </Form.Label>
                                            <Form.Select
                                                size="sm"
                                                aria-label="Default select"
                                                value={usuario.idCatTipoUsuario ?? ''}

                                                onChange={(e) => {
                                                    setUsuario(prev => ({
                                                        ...prev,
                                                        idCatTipoUsuario: Number(e.target.value)
                                                    }));
                                                }}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    padding: '8px 12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
                                            >
                                                <option value="">Selecciona un tipo de usuario</option>
                                                {tipoUsuario.map((tipo, index) => {
                                                    return (
                                                        <option
                                                            key={index}
                                                            value={tipo.idCatTipoUsuario}>
                                                            {tipo.idCatTipoUsuario} - {tipo.vNombreTipoUsuario}
                                                        </option>)
                                                })}
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiTag className="me-2 text-info" />
                                                <span>Categoria <span style={{ color: '#e74c3c' }}>*</span></span>
                                            </Form.Label>
                                            <Form.Control
                                                as="select"
                                                name="iCategoria"
                                                value={usuario.iCategoria ?? ''}
                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    padding: '8px 12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                            >
                                                <option value="">Selecciona la categoria</option>
                                                <option value="1">Empleado</option>
                                                <option value="2">Hon. Prof</option>
                                                <option value="3">Residente</option>
                                                <option value="4">Becario</option>
                                            </Form.Control>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiCheckCircle className="me-2 text-success" />
                                                <span>Estatus <span style={{ color: '#e74c3c' }}>*</span></span>
                                            </Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={activo ?? ''}

                                                onChange={(e) => setActivo(e.target.value)}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    padding: '8px 12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                            >
                                                <option value="">Selecciona el estado</option>
                                                <option value="1">✅ Activo</option>
                                                <option value="0">❌ Inactivo</option>
                                            </Form.Control>
                                        </Form.Group>

                                        {/* Credenciales de Acceso */}
                                        <div className="credentials-section mt-4">
                                            <h6 className="text-secondary mb-3 d-flex align-items-center">
                                                <div style={{ width: '4px', height: '20px', backgroundColor: '#6c757d', marginRight: '8px', borderRadius: '2px' }}></div>
                                                Credenciales de Acceso
                                            </h6>

                                            <Form.Group className="mb-3">
                                                <Form.Label className="d-flex align-items-center">
                                                    <FiMail className="me-2 text-secondary" />
                                                    <span>Usuario <span style={{ color: '#e74c3c' }}>*</span></span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    autoComplete="off"
                                                    name="vUsuario"
                                                    value={usuario.vUsuario ?? ''}

                                                    onChange={handleChange}
                                                    placeholder="Nombre de usuario"
                                                    style={{
                                                        borderRadius: '8px',
                                                        border: '2px solid #e9ecef',
                                                        paddingLeft: '12px',
                                                        transition: 'border-color 0.2s ease'
                                                    }}
                                                    onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                    onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                                />
                                            </Form.Group>

                                            <Form.Group className="mb-3">
                                                <div className="d-flex align-items-center justify-content-between mb-2">
                                                    <Form.Label className="d-flex align-items-center mb-0">
                                                        <FiLock className="me-2 text-secondary" />
                                                        <span>Contraseña <span style={{ color: '#e74c3c' }}>*</span></span>
                                                    </Form.Label>
                                                    <button
                                                        type="button"
                                                        onClick={() => { GenerarContrasena('Contrasena') }}
                                                        style={{
                                                            background: 'linear-gradient(135deg, #007bff, #0056b3)',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '6px',
                                                            padding: '6px 12px',
                                                            cursor: 'pointer',
                                                            fontSize: '12px',
                                                            fontWeight: '600',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            boxShadow: '0 2px 4px rgba(0,123,255,0.2)',
                                                            transition: 'all 0.2s ease'
                                                        }}
                                                        onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
                                                        onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}

                                                    >
                                                        <FiRefreshCw size={12} />
                                                        Generar
                                                    </button>
                                                </div>
                                                <Form.Control
                                                    type="text"
                                                    autoComplete="off"
                                                    name="vContrasena"
                                                    value={usuario.vContrasena ?? ''}

                                                    onChange={handleChange}
                                                    placeholder="Contraseña del usuario"
                                                    style={{
                                                        borderRadius: '8px',
                                                        border: '2px solid #e9ecef',
                                                        paddingLeft: '12px',
                                                        transition: 'border-color 0.2s ease',
                                                        fontFamily: 'monospace'
                                                    }}
                                                    onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                    onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>

                    <Card className="mt-3">
                        {empleado?.empleado?.idUsuario && (
                            <SeccionArchivosEmpleados
                                idEmpleado={empleado.empleado.idUsuario}
                            />
                        )}
                    </Card>

                    <Card className="mt-3">
                        <Card.Body className="p-4">
                          
                            <Row>
                                {/* Información de Contacto Laboral */}
                                <Col lg={6} md={12} className="mb-4">
                                    <div className="contact-info-section">
                                        <h6 className="text-secondary mb-3 d-flex align-items-center">
                                            <div style={{ width: '4px', height: '20px', backgroundColor: '#007bff', marginRight: '8px', borderRadius: '2px' }}></div>
                                            Información de Contacto Laboral
                                        </h6>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiPhone className="me-2 text-primary" />
                                                <span>Teléfono de trabajo</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                autoComplete="off"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                placeholder="Ingresa el teléfono de trabajo"
                                                name="vTelefonoTrabajo"
                                                value={usuario.vTelefonoTrabajo ?? ''}

                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    paddingLeft: '12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiMail className="me-2 text-success" />
                                                <span>Email de trabajo <span style={{ color: '#e74c3c' }}>*</span></span>
                                            </Form.Label>
                                            <Form.Control
                                                type="email"
                                                autoComplete="off"
                                                placeholder="Ingresa el Email de trabajo"
                                                name="vEmailTrabajo"
                                                value={usuario.vEmailTrabajo ?? ''}

                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    paddingLeft: '12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                            />
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiCalendar className="me-2 text-warning" />
                                                <span>Fecha de Ingreso <span style={{ color: '#e74c3c' }}>*</span></span>
                                            </Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="dFechaIngreso"
                                                value={usuario.dFechaIngreso?.split('T')[0] || ''}

                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    paddingLeft: '12px',
                                                    transition: 'border-color 0.2s ease'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                            />
                                        </Form.Group>
                                    </div>
                                </Col>

                                {/* Datos de Contacto Personal */}
                                <Col lg={6} md={12} className="mb-4">
                                    <div className="personal-contact-section">
                                        <h6 className="text-secondary mb-3 d-flex align-items-center">
                                            <div style={{ width: '4px', height: '20px', backgroundColor: '#28a745', marginRight: '8px', borderRadius: '2px' }}></div>
                                            Información Personal Adicional
                                        </h6>

                                        <Form.Group className="mb-3">
                                            <Form.Label className="d-flex align-items-center">
                                                <FiMessageSquare className="me-2 text-info" />
                                                <span>Datos de contacto personal</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                as="textarea"
                                                autoComplete="off"
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                placeholder="Datos de contacto adicionales personales (teléfono personal, dirección de emergencia, contacto familiar, etc.)"
                                                name="vDatosContactoPersonal"
                                                value={usuario.vDatosContactoPersonal ?? ''}

                                                onChange={handleChange}
                                                style={{
                                                    borderRadius: '8px',
                                                    border: '2px solid #e9ecef',
                                                    padding: '12px',
                                                    transition: 'border-color 0.2s ease',
                                                    resize: 'vertical',
                                                    minHeight: '160px'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#007bff'}
                                                onBlur={(e) => e.target.style.borderColor = '#e9ecef'}


                                            />
                                            <small className="text-muted d-flex align-items-center mt-1">
                                                <FiInfo className="me-1" size={12} />
                                                Incluye información adicional como contactos de emergencia, teléfonos alternativos, etc.
                                            </small>
                                        </Form.Group>
                                    </div>
                                </Col>
                            </Row>
                        </Card.Body>

                        <Card className="mt-3">
                            

                            <Card.Footer className="bg-light border-top">
                                <Row className="d-flex justify-content-end align-items-center">
                                    <Col xs="auto" className="d-flex gap-3">
                                        <Link to='/contabilidad/empleados'>
                                            <Button
                                                variant="outline-danger"
                                                className="px-4 py-2 d-flex align-items-center"
                                                style={{
                                                    borderRadius: '8px',
                                                    fontWeight: '600',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseOver={(e) => {
                                                    e.target.style.backgroundColor = '#dc3545';
                                                    e.target.style.color = 'white';
                                                    e.target.style.borderColor = '#dc3545';
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.backgroundColor = 'transparent';
                                                    e.target.style.color = '#dc3545';
                                                    e.target.style.borderColor = '#dc3545';
                                                }}
                                            >
                                                <FiX className="me-2" size={16} />
                                                Cancelar
                                            </Button>
                                        </Link>

                                        {!guardando ? (
                                            <Button
                                                variant="primary"
                                                className="px-4 py-2 d-flex align-items-center"
                                                type="submit"
                                                disabled={
                                                    usuario.vUsuario === "" ||
                                                    usuario.vNombre === "" ||
                                                    usuario.vContrasena === "" ||
                                                    usuario.vApellidos === "" ||
                                                    usuario.idCatTipoUsuario === "" ||
                                                    usuario.dFechaNacimiento === "" ||
                                                    usuario.vEmailTrabajo === "" ||
                                                    usuario.dFechaIngreso === "" ||
                                                    usuario.iCategoria === "" ||
                                                    activo === ''
                                                }
                                                onClick={guardarUsuario}
                                                style={{
                                                    borderRadius: '8px',
                                                    fontWeight: '600',
                                                    background: 'linear-gradient(135deg, #007bff, #0056b3)',
                                                    border: 'none',
                                                    boxShadow: '0 2px 8px rgba(0,123,255,0.3)',
                                                    transition: 'all 0.2s ease'
                                                }}
                                                onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
                                                onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}

                                            >
                                                <FiSave className="me-2" size={16} />
                                                Guardar
                                            </Button>
                                        ) : (
                                            <Button
                                                variant="primary"
                                                className="px-4 py-2 d-flex align-items-center"
                                                type="submit"
                                                disabled
                                                onClick={guardarUsuario}
                                                style={{
                                                    borderRadius: '8px',
                                                    fontWeight: '600',
                                                    background: '#6c757d',
                                                    border: 'none'
                                                }}
                                            >
                                                <FiLoader className="me-2 spinner-border spinner-border-sm" size={16} />
                                                Guardando...
                                            </Button>
                                        )}
                                    </Col>
                                </Row>
                            </Card.Footer>
                        </Card>
                    </Card>
            </>
                :
                (<h5><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h5>)
            }
        </>
    );
};

RegistroEmpleado.propTypes = {

    empleado: PropTypes.object
}

    export default RegistroEmpleado